import { ChartVariant } from '../types/timeseries-props.js';

/**
 * @param variant - The variant (or type) of the Chart, e.g. 'line', 'area', 'bar', etc.

 * @returns true if the given ChartVariant is bar
 */
export function isBar(variant: ChartVariant): boolean {
  return variant === 'bar';
}
